import { Pipe, PipeTransform } from '@angular/core';
import { cond, constant, stubTrue } from 'lodash';

import { QuoteStatus, Role, RoleType } from '@lockton-apps/shared/interfaces';
import {
  quoteStatusBrokerMeta,
  quoteStatusContactMeta,
} from './quote-status-meta';

@Pipe({
  name: 'quoteStatusDescription',
  standalone: true,
})
export class QuoteStatusDescriptionPipe implements PipeTransform {
  contactMap = quoteStatusContactMeta;

  brokerMap = quoteStatusBrokerMeta;

  transform(value: QuoteStatus, role: RoleType = Role.Contact): string {
    return (
      cond([
        [() => role === Role.Contact, constant(this.contactMap.get(value))],
        [stubTrue, constant(this.brokerMap.get(value))],
      ])() || 'help'
    );
  }
}
